import sortByPosition from '@/lib/utils/sorting/sortByPosition';
import ModelFieldEditor from './ModelFieldEditor';
import type ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import { type EditorField } from '@/lib/types';

type ModelFieldEditorListProps = {
  fields: EditorField[];
  highestFieldPositions: Record<ContentGroupType, number>;
  lowestFieldPositionInSectionBottomContent: number;
};

const ModelFieldEditorList = ({
  fields,
  highestFieldPositions,
  lowestFieldPositionInSectionBottomContent,
}: ModelFieldEditorListProps) => {
  const sortedFields = fields.sort(sortByPosition);

  return sortedFields.map((field, index) => (
    <ModelFieldEditor
      field={field}
      previousField={sortedFields[index - 1]}
      nextField={sortedFields[index + 1]}
      allHighestPositions={highestFieldPositions}
      lowestFieldPositionInSectionBottomContent={
        lowestFieldPositionInSectionBottomContent
      }
      key={field.id}
    />
  ));
};

export default ModelFieldEditorList;
